import http from '@amit/composables/src/useHttp';
import { useApi } from '@amit/composables';
//?? MOVE TO COURSE SERVICES
export const fetchPages = (course: string, lesson: string) => {
  return useApi(http.get(`/courses/${course}/lessons/${lesson}/pages`));
};
